<template>
  <div>
    <h4 class="my-4 p-dark-gray--text">{{ $t('relations.textHasRelations') }}</h4>
    <v-simple-table dense>
      <template v-slot:default>
        <tbody>
        <tr
          v-for="relation in relationsList"
          :key="relation.name"
        >
          <td>{{ $t(`relations.relationListItem-${relation.name}`) }}</td>
          <td>{{ relation.count }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>

</template>

<script>
export default {
  props: {
    relationsList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
